/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getThreadedViewData} from '../api'

 export const useQueryGetThreadedViewData = createReactQueryHook('getThreadedViewData', getThreadedViewData)
